import type { Component } from "vue";

type IconLoader = () => Promise<{ default: Component }>;

export const Icon = {
  IconCommunity: "IconCommunity",
  IconDeselect: "IconDeselect",
  IconDocumentation: "IconDocumentation",
  IconEcosystem: "IconEcosystem",
  IconGoogle: "IconGoogle",
  IconOpenIndicator: "IconOpenIndicator",
  IconSupport: "IconSupport",
  IconTooling: "IconTooling",
  Add: "add",
  ArrowDown: "arrow-down",
  ArrowLeft: "arrow-left",
  ArrowRight: "arrow-right",
  AtSign: "at-sign",
  Bin: "bin",
  Calendar: "calendar",
  ChevronLeft: "chevron-left",
  ChevronRight: "chevron-right",
  Clock: "clock",
  Cog: "cog",
  Comments: "comments",
  Dots: "dots",
  Edit: "edit",
  Email: "email",
  HandHeart: "hand-heart",
  List: "list",
  Loading: "loading",
  Lock: "lock",
  Menu: "menu",
  Music: "music",
  People: "people",
  Phone: "phone",
  Plus: "plus",
  Refresh: "refresh",
  Search: "search",
  Settings: "settings",
  Songs: "songs",
  Spinner: "spinner",
  Subtract: "subtract",
  Tick: "tick",
  User: "user",
  Users: "users",
  X: "x",
} as const;

export type IconName = (typeof Icon)[keyof typeof Icon];

export const icons = {
  IconCommunity: () => import("./icons/IconCommunity.vue"),
  IconDeselect: () => import("./icons/IconDeselect.vue"),
  IconDocumentation: () => import("./icons/IconDocumentation.vue"),
  IconEcosystem: () => import("./icons/IconEcosystem.vue"),
  IconGoogle: () => import("./icons/IconGoogle.vue"),
  IconOpenIndicator: () => import("./icons/IconOpenIndicator.vue"),
  IconSupport: () => import("./icons/IconSupport.vue"),
  IconTooling: () => import("./icons/IconTooling.vue"),
  add: () => import("./icons/add.vue"),
  "arrow-down": () => import("./icons/arrow-down.vue"),
  "arrow-left": () => import("./icons/arrow-left.vue"),
  "arrow-right": () => import("./icons/arrow-right.vue"),
  "at-sign": () => import("./icons/at-sign.vue"),
  bin: () => import("./icons/bin.vue"),
  calendar: () => import("./icons/calendar.vue"),
  "chevron-left": () => import("./icons/chevron-left.vue"),
  "chevron-right": () => import("./icons/chevron-right.vue"),
  clock: () => import("./icons/clock.vue"),
  cog: () => import("./icons/cog.vue"),
  comments: () => import("./icons/comments.vue"),
  dots: () => import("./icons/dots.vue"),
  edit: () => import("./icons/edit.vue"),
  email: () => import("./icons/email.vue"),
  "hand-heart": () => import("./icons/hand-heart.vue"),
  list: () => import("./icons/list.vue"),
  loading: () => import("./icons/loading.vue"),
  lock: () => import("./icons/lock.vue"),
  menu: () => import("./icons/menu.vue"),
  music: () => import("./icons/music.vue"),
  people: () => import("./icons/people.vue"),
  phone: () => import("./icons/phone.vue"),
  plus: () => import("./icons/plus.vue"),
  refresh: () => import("./icons/refresh.vue"),
  search: () => import("./icons/search.vue"),
  settings: () => import("./icons/settings.vue"),
  songs: () => import("./icons/songs.vue"),
  spinner: () => import("./icons/spinner.vue"),
  subtract: () => import("./icons/subtract.vue"),
  tick: () => import("./icons/tick.vue"),
  user: () => import("./icons/user.vue"),
  users: () => import("./icons/users.vue"),
  x: () => import("./icons/x.vue"),
} satisfies Record<IconName, IconLoader>;
